export const getDefaultValues = (templateIds: number[]) => {
  const defaultValues = {} as Record<number, boolean>

  templateIds.forEach(id => {
    defaultValues[id] = false
  })

  return defaultValues
}

export const convertToSelectedTemplateIds = (
  formValues: ReviewFormValues,
): number[] => {
  return Object.entries(formValues)
    .filter(([_, value]) => value)
    .map(([key]) => Number(key))
}

export type ReviewFormValues = Record<number, boolean>
